import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

/**
 * Route component that only allows access to users with the admin role.
 * If the user is not an admin, they are redirected to the dashboard.
 */
const AdminRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has admin role
  if (!currentUser.role || currentUser.role !== 'admin') {
    // Redirect to dashboard if not an admin
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  // User is authenticated and has admin role
  return children;
};

export default AdminRoute;
